import { useEffect, useMemo } from "react";
import {
  syncDataAttributes,
  useStylesConfig,
  type VariantOverridesInput,
} from "../stores/styles-config";

/**
 * Syncs styles config resolved values to `data-config-*` attributes on
 * `document.documentElement` and optionally seeds variant overrides.
 *
 * Call once per surface (e.g. PrototypeChatSurface, MockChatPage).
 */
export function useStylesConfigSync(variantInput?: VariantOverridesInput): void {
  const setVariantOverrides = useStylesConfig((s) => s.setVariantOverrides);

  // Serialize to stabilize object identity — callers pass inline literals
  const inputKey = JSON.stringify(variantInput);
  const stableInput = useMemo(() => variantInput, [inputKey]);

  useEffect(() => {
    if (stableInput) {
      setVariantOverrides(stableInput);
    }
  }, [stableInput, setVariantOverrides]);

  useEffect(() => {
    syncDataAttributes(useStylesConfig.getState().getResolved());

    return useStylesConfig.subscribe((state) => {
      syncDataAttributes(state.getResolved());
    });
  }, []);
}
